/* Built In Imports */
import { useContext, useEffect } from 'react';

/* External Imports */
import { Box } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import WrapLayout from '@Layout/WrapLayout';
import SectionTitle from '@components/Headings/SectionTitle';
import StyleConfig from '@components/UI/Common/StyleConfig';
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';
import SubscribeContent from '@components/UI/Subscribe/SubscribeContent';
import HeadComponent from '@components/Utility/HeadComponent';
import config from '@config';
import { AuthContext } from '@store/auth-context';

/* Services */
import { getLocale } from '@components/Utility/Shared/SharedService';
import {
  fetchFooterData,
  fetchHeaderMenuData,
  fetchHeaderTopMenuData,
} from 'services/commonService';
import {
  fetchDetails,
  getLandingPaths,
} from 'services/quotesubscriptionService';

/* Styles */

/**
 *
 * @param {string} region - Current User Region
 * @param {string} language - Current User Language
 * @param {string} pageData - Health Landing Page Data
 */

const DailyQuoteSubscription = ({ region, language, pageData }) => {
  const authContext = useContext(AuthContext);
  const section = pageData.body[0];
  const secContent = section.sectionContent;

  useEffect(() => {
    authContext.RegionAndLang(region, language);
  }, [authContext, region, language]);

  return (
    <WrapLayout>
      <HeadComponent
        data={pageData?._seoMetaTags || pageData?.seoFields}
        availableLocals={pageData.availableLocales}
      >
        {' '}
      </HeadComponent>
      <Box as="section" className="page-wrap container-article">
        <SectionTitle titleObj={secContent[0]} />
        <StyleConfig
          id={section?.sectionId}
          key={section.sectionId}
          style={section?.styleConfig}
          mb="30px"
          pb="0"
        >
          <Box
            display={{ base: 'block', md: 'flex' }}
            mb="20px"
            alignContent="center"
          >
            <Box
              // w={{ base: '100%', md: '40%', lg: '40%' }}
              textAlign={{ base: 'center', md: 'right' }}
              mb={{ base: '20px', md: '0' }}
              pl={{ base: '0', md: '20px' }}
            >
              <LazyLoadImageComponent
                src={secContent[2]?.image?.url}
                title="Sadhguru Quotes"
                alt="Sadhguru Quotes"
              />
            </Box>
            <Box
              // w={{ base: '100%', md: '50%', lg: '55%' }}
              display="inline-flex"
              // alignItems="center"
            >
              <SubscribeContent
                contentType="quotes"
                region={region}
                contentObj={secContent[1]}
                pType="dailysubscription"
              />
            </Box>
          </Box>
        </StyleConfig>
      </Box>
    </WrapLayout>
  );
};

export const getStaticPaths = async () => {
  const quotesubscriptionPaths = config.USE_LOCAL_URL
    ? [`/in/en/daily-quotes-subscription`]
    : await getLandingPaths('lvl0', '/daily-quotes-subscription');
  return {
    paths: quotesubscriptionPaths,
    fallback: false,
  };
};

export const getStaticProps = async ({
  preview,
  previewData,
  params: { region, language },
  req,
}) => {
  const headerTopMenuData = await fetchHeaderTopMenuData(
    getLocale(region, language),
    'isotopmenu'
  );
  const headerMenuData = await fetchHeaderMenuData(
    getLocale(region, language),
    'isomainmenu'
  );
  const footerData = await fetchFooterData(
    getLocale(region, language),
    'isofooter'
  );
  const pageData = await fetchDetails(region, language);

  return {
    props: {
      headerTopMenuData: headerTopMenuData?.data || null,
      headerMenuData: headerMenuData?.data || null,
      region: region,
      language: language,
      footerData: footerData?.data || null,
      pageData: pageData || null,
      isPreview: preview ? true : false,
    },
  };
};

export default DailyQuoteSubscription;
